import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode'; // Use named import instead of default import
import '../css/Form.css';

const UpdateUser = () => {
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    phone: '',
    dateOfBirth: ''
  });
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const navigate = useNavigate();

  // Check if the user is authorized when the component mounts
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      // Redirect to login page if no token is present
      navigate('/login');
    } else {
      
      try {
        const decodedToken = jwtDecode(token); // Correct use of jwt-decode
        const currentTime = Date.now() / 1000; // Get current time in seconds

        // Check if the token is expired
        if (decodedToken.exp < currentTime) {
          localStorage.removeItem('token'); // Remove expired token
          navigate('/login'); // Redirect to login page
        }
      } catch (error) {
        console.error('Error decoding token:', error);
        navigate('/login'); // Redirect to login page if decoding fails
      }
    }
  }, [navigate]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMessage('');

    try {
      const token = localStorage.getItem('token');
      if (!token) {
        setError('Unauthorized! Please login.');
        navigate('/login');
        return;
      }

      // Make PUT request to update user details
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/api/user/update`, // No need for userId in the URL
        formData, // Send the form data directly
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setSuccessMessage('Update successful!');
      // You can redirect to another page after successful update if needed
      // navigate('/profile');
    } catch (error) {
      if (error.response) {
        setError(`Error: ${error.response.data.message}`);
      } else if (error.request) {
        setError('Network error, please try again later.');
      } else {
        setError('An error occurred. Please try again.');
      }
    }
  };

  return (
    <div className="form-container">
      <h2>Update User</h2>

      {error && <div className="error-message">{error}</div>}
      {successMessage && <div className="success-message">{successMessage}</div>}

      <form onSubmit={handleSubmit}>
        <div>
          <label>New Username:</label>
          <input
            type="text"
            name="username"
            value={formData.username}
            onChange={handleChange}
            placeholder="Username (optional)"
          />
        </div>
        <div>
          <label>New Password:</label>
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            placeholder="Password (optional)"
          />
        </div>
        <div>
          <label>Phone:</label>
          <input
            type="text"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="Phone (optional)"
          />
        </div>
        <div>
          <label>Date of Birth:</label>
          <input
            type="date"
            name="dateOfBirth"
            value={formData.dateOfBirth}
            onChange={handleChange}
            placeholder="Date of Birth (optional)"
          />
        </div>
        <button type="submit">Update</button>
      </form>
    </div>
  );
};

export default UpdateUser;
